// extracted by mini-css-extract-plugin
module.exports = {"news":"NewsGroup_news__21jmS","content":"NewsGroup_content__2SRWE","list":"NewsGroup_list__No49z","scroll":"NewsGroup_scroll__19U2w"};